import { ParsedUrlQuery } from 'querystring';
import {
    getAdded,
    getAvailableFrom,
    getBedsMax,
    getBedsMin,
    getBillsIncluded,
    getFeatures,
    getFurnishedState,
    getIncludeRented,
    getIncludeSharedAccommodation,
    getIsRetirementHome,
    getKeywords,
    getPetsAllowed,
    getPriceFrequency,
    getPriceMax,
    getPriceMin,
    getPropertySubType,
    getPropertyType,
    getRentalTerm,
    getIsStudentAccommodation,
    getIsSharedAccommodation
} from '.';

export const getDefaultToRentFilters = () => {
    return {
        beds_min: '',
        beds_max: '',
        price_min: '',
        price_max: '',
        price_frequency: 'per_month',
        added: '',
        available_from: '',
        property_type: 'property',
        property_sub_type: [],
        rental_term: '',
        bills_included: '',
        pets_allowed: '',
        include_rented: '',
        include_shared_accommodation: '',
        is_retirement_home: '',
        is_shared_accommodation: '',
        is_student_accommodation: '',
        furnished_state: '',
        feature: [],
        keywords: ''
    };
};

export const getToRentFilters = (query: ParsedUrlQuery) => {
    return {
        beds_min: getBedsMin(query),
        beds_max: getBedsMax(query),
        price_min: getPriceMin(query),
        price_max: getPriceMax(query),
        price_frequency: getPriceFrequency(query),
        added: getAdded(query),
        available_from: getAvailableFrom(query),
        property_type: getPropertyType(query),
        property_sub_type: getPropertySubType(query),
        rental_term: getRentalTerm(query),
        bills_included: getBillsIncluded(query),
        pets_allowed: getPetsAllowed(query),
        is_retirement_home: getIsRetirementHome(query),
        is_student_accommodation: getIsStudentAccommodation(query),
        include_rented: getIncludeRented(query),
        is_shared_accommodation: getIsSharedAccommodation(query),
        include_shared_accommodation: getIncludeSharedAccommodation(query),
        furnished_state: getFurnishedState(query),
        feature: getFeatures(query),
        keywords: getKeywords(query)
    };
};
